import React from "react";

const ActionList = (props) => {
  const {rx_action_list, t_delete_action_by_id} = props
  //console.log(rx_action_list)
  if (!rx_action_list) return <></>

  //console.log(rx_action_list)
  return (
    <>
    {/* <p>Hello from ActionList</p> */}
    <DataTable 
    data = {rx_action_list} 
    t_delete_action_by_id = {t_delete_action_by_id}
    />
    </>
  )
}

export default ActionList;

const DataTable = ({ data, t_delete_action_by_id }) => {
  if (!data || data.length === 0) {
      return <p>No data available</p>;
  }
  const handleDelete =(action_id) => {
    //console.log(action_id)
    t_delete_action_by_id(action_id)

  }
  return (
    <div className="container mt-5">
    <h2>Action List</h2>
      <table className="table table-striped">
            <thead>
                <tr>
                    <th>ID</th>
                    {/* <th>Dev ID</th> */}
                    <th>Code</th>
                    <th>Value</th>
{/*                     <th>Float Value</th>
                    <th>String Value</th> */}
                    <th>Result</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item) => (
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        {/* <td>{item.dev_id}</td> */}
                        <td>{item.code}</td>
                        <td>{item.int_value}</td>
{/*                         <td>{item.float_value !== null ? item.float_value : '-'}</td>
                        <td>{item.str_value !== null ? item.str_value : '-'}</td> */}
                        <td>{item.result !== null ? item.result : '-'}</td>
                        <td>
                            <button onClick={() => handleDelete(item.id)}>Delete</button> {/* Delete button */}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
  );
};